module.exports = __webpack_public_path__ + "static/media/check-green.50e4a91e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/check-green.svg
// module id = 1046
// module chunks = 0